function DNDNoScript({ src, elementStyle, changeSelection }) {
  return (
    <div
      id="noscript"
      data-tour="rpdesigner-step-3"
      style={{ display: 'inherit' }}
      onClick={changeSelection}
    >
      {src}
    </div>
  );
}

export default DNDNoScript;
